import Tick from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Tick24PxOutlined";
import Info from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Info24PxOutlined";
import styles from "./DeliveryHighlightMessage.module.scss";

export type ClickAndCollectMessageProps = {
  isClickAndCollectAvailable: boolean;
  isOverClickAndCollectThreshold: boolean;
};

export const ClickAndCollectMessage = ({
  isClickAndCollectAvailable,
  isOverClickAndCollectThreshold,
}: ClickAndCollectMessageProps) => {
  if (!isClickAndCollectAvailable) {
    return (
      <div
        className={styles.deliveryMessage}
        data-testid="product:delivery-message:click-and-collect"
      >
        <Info /> <span>Click & Collect not available for this item</span>
      </div>
    );
  }

  return (
    <div
      className={styles.deliveryMessage}
      data-testid="product:delivery-message:click-and-collect"
    >
      <Tick />{" "}
      <span>
        Free Click & Collect{isOverClickAndCollectThreshold ? "" : " over £30"}
      </span>
    </div>
  );
};
